import Icon from 'components/base/Icon';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import _ from 'lodash';
import { StyledChipV2 } from 'components/base/ChipV2';
import styled from 'styled-components';

export const StyledFilterChip = styled(StyledChipV2)`
  border-radius: 0rem;
  & svg#close {
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }
`;

const FilterChip = ({ text, onClose = _.noop }) => {
  return (
    <StyledFilterChip>
      <Flex items='center' justify='center'>
        <Text weight={400} size='normal' mr='0.5rem'>
          {text}
        </Text>
        <Icon
          name='close'
          size='smaller'
          color='shuttleGray'
          onClick={onClose}
        />
      </Flex>
    </StyledFilterChip>
  );
};

export default FilterChip;
